import Axios from 'axios'
import Autenticacao from './Autenticacao'

const apiUrl = `${process.env.API_URL}`

const formatar = (url) => `${apiUrl}/${url}`

const backendDelete = (url) => {
  return Autenticacao.pegarToken()
    .then(idToken => {
      return Axios.delete(formatar(url), {
        headers: {
          'x-access-token': idToken
        }
      })
    })
}

const backendGet = (url) => {
  return Autenticacao.pegarToken()
    .then(idToken => {
      return Axios.get(formatar(url), {
        headers: {
          'x-access-token': idToken
        }
      })
    })
}

const backendPost = (url, data) => {
  return Autenticacao.pegarToken()
    .then(idToken => {
      return Axios.post(formatar(url), data, {
        headers: {
          'x-access-token': idToken
        }
      })
    })
}

const backendGetTypeBlob = (url) => {
  return Autenticacao.pegarToken()
    .then(idToken => {
      return Axios.get(formatar(url), {
        headers: {
          'x-access-token': idToken
        },
        responseType: 'blob'
      })
    })
}

const get = (url) => Axios.get(url)

const post = (url, data) => Axios.post(url, data)

export default {
  backendDelete,
  backendGet,
  backendPost,
  get,
  post,
  backendGetTypeBlob
}



// WEBPACK FOOTER //
// ./src/services/HTTP.js